// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import {
  getArtikel,
  getArtikelgruppen,
  getSachgruppen,
} from "./ArtikelService";
import { IArtikelFilter } from "../../../Models/IArtikelFilter";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import {
  Dropdown,
  Field,
  Input,
  Option,
  Button,
} from "@fluentui/react-components";
import { FilterRegular, SearchRegular } from "@fluentui/react-icons";
import { ILuebOption } from "../../../Models/ILuebOption";

// Props
interface IArtikelFilterProps {
  onSearchStarted: any;
  onSearchResult: any;
  onFilterValuesChange: any;
}

// Function
function ArtikelFilter(props: IArtikelFilterProps) {
  const [sachgruppen, setSachgruppen] = useState<ILuebOption[]>([]);
  const [artikelgruppen, setArtikelgruppen] = useState<ILuebOption[]>([]);

  const [artikelFilterObj, setArtikelFilterObj] = useState<IArtikelFilter>({
    artikelId: "",
    benennung: "",
    sachGruppeGuid: "",
    artikelGruppeGuid: "",
  });
  const handleArtikelFilterObjValuesChange = (name: string, data: any) => {
    setArtikelFilterObj((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  };

  useEffect(() => {
    getSachgruppen().then((sachgruppen: ILuebOption[]) => {
      setSachgruppen(sachgruppen);
    });

    getArtikelgruppen().then((artikelgruppen: ILuebOption[]) => {
      setArtikelgruppen(artikelgruppen);
    });
  }, []);

  const _getArtikel = () => {
    props.onSearchStarted();
    getArtikel(
      artikelFilterObj.artikelId,
      artikelFilterObj.benennung,
      artikelFilterObj.sachGruppeGuid,
      artikelFilterObj.artikelGruppeGuid,
    ).then((parts) => {
      props.onSearchResult(parts);
    });
  };

  useEffect(() => {
    props.onFilterValuesChange(artikelFilterObj);
  }, [artikelFilterObj]);

  return (
    <>
      <div
        className="lueb-ContentBlock"
        onKeyDown={(data) => {
          if (data.key == "Enter") {
            _getArtikel();
          }
        }}
      >
        <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field label={"Artikel ID"}>
              <Input
                value={artikelFilterObj.artikelId}
                onChange={(ev, data) =>
                  handleArtikelFilterObjValuesChange(
                    "artikelId",
                    data ? data.value : "",
                  )
                }
                contentAfter={<FilterRegular />}
              />
            </Field>
          </StackItemShim>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field label={"Benennung"}>
              <Input
                value={artikelFilterObj.benennung}
                onChange={(ev, data) =>
                  handleArtikelFilterObjValuesChange(
                    "benennung",
                    data ? data.value : "",
                  )
                }
                contentAfter={<FilterRegular />}
              />
            </Field>
          </StackItemShim>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field label={"Sachgruppe"}>
              <Dropdown
                onOptionSelect={(ev, data) => {
                  handleArtikelFilterObjValuesChange(
                    "sachGruppeGuid",
                    data.optionValue,
                  );
                }}
                selectedOptions={[artikelFilterObj.sachGruppeGuid]}
                value={
                  sachgruppen.find(
                    (x) => x.key == artikelFilterObj.sachGruppeGuid,
                  )?.text
                    ? sachgruppen.find(
                        (x) => x.key == artikelFilterObj.sachGruppeGuid,
                      )?.text
                    : ""
                }
              >
                {sachgruppen.map((item) => {
                  return (
                    <Option value={typeof item.key == "string" ? item.key : ""}>
                      {item.text}
                    </Option>
                  );
                })}
              </Dropdown>
            </Field>
          </StackItemShim>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field label={"Artikelgruppe"}>
              <Dropdown
                onOptionSelect={(ev, data) => {
                  handleArtikelFilterObjValuesChange(
                    "artikelGruppeGuid",
                    data.optionValue,
                  );
                }}
                selectedOptions={[artikelFilterObj.artikelGruppeGuid]}
                value={
                  artikelgruppen.find(
                    (x) => x.key == artikelFilterObj.artikelGruppeGuid,
                  )?.text
                    ? artikelgruppen.find(
                        (x) => x.key == artikelFilterObj.artikelGruppeGuid,
                      )?.text
                    : ""
                }
              >
                {artikelgruppen.map((item) => {
                  return (
                    <Option value={typeof item.key == "string" ? item.key : ""}>
                      {item.text}
                    </Option>
                  );
                })}
              </Dropdown>
            </Field>
          </StackItemShim>
        </StackShim>
        <Button
          style={{ marginTop: "5px" }}
          onClick={() => {
            _getArtikel();
          }}
          appearance="primary"
          icon={<SearchRegular />}
        >
          Suchen
        </Button>
      </div>
    </>
  );
}

// Export Function
export default ArtikelFilter;
